// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const EyeOffIcon = /* @__PURE__ */ createIcon(
  'eye-off',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M2.292 2.293a1 1 0 0 1 1.415 0l3.64 3.64a1 1 0 0 1 .151.151L17.9 16.485q.095.074.17.171l3.637 3.637a1 1 0 0 1-1.415 1.414l-3.155-3.155C15.693 19.397 13.971 20 12 20c-2.86 0-5.194-1.264-6.922-2.707-1.727-1.44-2.91-3.107-3.503-4.046-.12-.19-.289-.44-.371-.8a2.2 2.2 0 0 1 0-.894c.082-.36.251-.612.372-.802.602-.954 1.827-2.674 3.622-4.14L2.292 3.707a1 1 0 0 1 0-1.414m4.326 5.74c-1.64 1.293-2.784 2.888-3.352 3.786l-.11.18.028.05c.02.035.046.075.081.13.533.844 1.587 2.32 3.093 3.578C7.862 17.012 9.756 18 12 18c1.352 0 2.577-.359 3.666-.919l-1.635-1.636a4 4 0 0 1-5.477-5.477zM11.999 4c2.862 0 5.196 1.264 6.924 2.707 1.727 1.44 2.91 3.107 3.502 4.046.105.166.248.378.337.67l.035.13.035.217a2.2 2.2 0 0 1-.035.677c-.082.36-.252.612-.373.803a18.5 18.5 0 0 1-1.441 1.973 1 1 0 0 1-1.533-1.285 16.5 16.5 0 0 0 1.283-1.756l.082-.131.03-.051-.03-.05-.08-.13c-.533-.843-1.587-2.32-3.093-3.577C16.138 6.988 14.242 6 12 6q-.573.002-1.11.082a1 1 0 0 1-.294-1.978A9.6 9.6 0 0 1 12 4m-8.842 8.025v-.002l-.001-.002zM9.999 12a2 2 0 0 0 2 2c.18 0 .351-.027.516-.07l-2.446-2.447q-.068.248-.07.517',
      },
    ],
  ]
);
